export const widgetsFinance = '/widgets-finance'